import styled from 'styled-components';
import theme from '../../../config/theme';

const Checkbox = styled.input`
  margin-right: ${theme.spacing.xs};
`;

export default Checkbox;
